import type { PrimaryCountryISO } from '@/constants/countries';
import useIndustriesFetch from '@/pages/Market/hooks/useIndustriesFetch';

interface Industry {
  label: string;
  companyCount: number | null;
}

export default function (industryId: number, market: string): Industry | null {
  const { industries } = useIndustriesFetch(market as PrimaryCountryISO, false);
  if (industries.sector[industryId]) {
    return industries.sector[industryId];
  }
  if (industries.secondary[industryId]) {
    return industries.secondary[industryId];
  }
  if (industries.tertiary[industryId]) {
    return industries.tertiary[industryId];
  }
  return null;
}
